function init() {
    // Textbausteine erstellen/Bearbeiten
    if ($('.ok.cleanup-data').length > 0) {
        initCleanup();
    }
}
function initCleanup() {
    var currentItem = null;
    var url = '/Handler/HvD/Cleanup';
    var dlg_cleanup = $('#dlg-cleanup').dialog({
        autoOpen: false,
        modal: true,
        width: 400,
        title: 'Datenbereinigung',
        height: 300,
        maxHeight: 540,
        buttons: [
            {
                text: 'Ok',
                class: 'ok',
                click: function () {
                    $.ajax({
                        cache: false,
                        type: 'POST',
                        url: url,
                        data: { data: { type: 'cleanup' } }
                    }).done(function (data) {
                        if (data === 'ok') {
                            dlg_cleanup.dialog('close');
                        } else {
                            alert("Es ist ein fehler aufgetreten\n" + data);
                            dlg_cleanup.dialog('close');
                        }
                    });
                }
            },
            {
                text: 'Abbrechen',
                class: 'cancel',
                click: function () {
                    $(this).dialog('close');
                }
            }
        ]
    });
    $('.ok.cleanup-data').click(function (event) {
        dlg_cleanup.dialog('open');
    });
}
init();
